/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const win = window;

export const TEXT_CONSTANTS = {
  winSize: win.innerWidth,
  noOfMonths: 11,
  noOfDigits: 10,
  BREAK_POINT_MOBILE: 320,
  BREAK_POINT_TABLET: 768,
  BREAK_POINT_DESKTOP: 992,
  DESKTOP_CHAR_LIMIT: 94,
  TABLET_CHAR_LIMIT: 71,
  MOBILE_CHAR_LIMIT: 30,
  stripSizeForSmallScreen: 2,
  stripSizeForLargeScreen: 4,
  CAROUSAL_SIZE: 3,
  oneFiftyEight: 158,
  scrollSizeForDesktop: 197,
  scrollSizeForTab: 151,
  scrollSizeForMobile: 128,
  DEVICE_DESKTOP: 'Desktop',
  DEVICE_TABLET: 'Tablet',
  DEVICE_MOBILE: 'Mobile',
  MRC: 'MRC',
  THIRDPARTY_CHARGES: 'THIRDPARTY_CHARGES',
  ONETIME_CHARGES: 'ONETIME_CHARGES',
  MONTH_NAMES: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  YEARS: ['2017', '2018', '2019'],
  ROLE_TYPE: 'account owner',
  ACCOUNTMANAGER_ROLE: 'account manager',
  ACCOUNTMANAGER: 'ACTIVITY_ACCOUNT_MANAGER',
  ACCOUNTOWNER: 'ACTIVITY_ACCOUNT_OWNER',
  LINK: 'link',
  BUTTON: 'button',
  CASH: 'cash',
  DEBIT_CREDIT: 'debitCredit',
  IMAGE: 'Image',
  OF: 'Of',
  PREVIOUSBUTTON: 'Previous Button',
  NEXTBUTTON: 'Click to scroll through Carousel',
  TIMEINTERVAL: 60,
  TIMEFORMAT: 'hh:mm A',
  IMAGENOTFOUND: '/General/No_image_available.jpg',
  RESTORE_SERVICE: 'RESTORE SERVICE',
  OPEN_TOOLS_TAB: 'openToolsTab',
  TILL_STATUS: 'tillStatus',
  CHANGE_STORE: 'changeStore',
  CLOSE_TOOL_SLIDER: 'closeToolsSlider',
  APP_RENDERED: 'appRendered',
};

export const DEVICE_CONSTANTS = {
  TYPE_SIM: 'sim',
  TYPE_IMEI: 'imei',
  TYPE_SKU: 'sku',
};

export const CARD_CONSTANTS = {
  CREDIT: 'Credit',
  SWIPECC: 'swipecc.k3z',
  CCODM: 'ccodm.k3z',
  HYBRID: 'hybrid',
};

export const LINE_CONSTANTS = {
  LOST_STOLEN: 'ELSTS',
  SUSPENDED: 'SUSPENDED',
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  PRIMARY: 'PRIMARY',
};

export const SYMBOL_CONSTANTS = {
  HYPHEN: '-',
  SPACE: ' ',
  COMMA: ',',
  COLON: ':',
  HASH: '#',
  SLASH: '/',
  DOLLAR: '$',
  ASTERIX: '*',
};

export const NUMBER_CONSTANTS = {
  ZERO: 0,
  TWO: 2,
};

export const WINDOW_PRINT_CONST = {
  TEMPLATE:
    '<html><body onload="window.print()">' + '<h1>HEADER</h1>' + 'PRINT_DATE' + '<br>HTML</html>',
  HEADER: 'HEADER',
  PRINT_DATE: 'PRINT_DATE',
  DATE_FORMAT: 'YYYY-MM-DD hh:mm:ss.S',
  COLON: ':',
  HTML: 'HTML',
  WINDOW_TERGET: '_blank',
  WINDOW_FEATURES: 'width=600,height=700',
  PDF_FILE_NAME: '-orderReceipt.pdf',
  LINK_SOURCE_PREFIX: 'data:application/pdf;base64,',
  LINK_SOURCE_PREFIX_IE: 'application/pdf',
};

export const CONTENT_PATH_CONSTANT = {
  CONTENT_PATHS: '/bin/api/v1/contentPaths.json',
};

export const ROUTE_CONSTANTS = {
  BILLING_LANDING_ROUTE: '/billing-landing',
  STORE_OPS_ROUTE: 'store-ops',
  CUSTOMER_ACTIVITY_LOG: '/customer-activity-log',
  ONE_TIME_PAYMENT: '/one-time-payment',
  AUTOPAY: '/autopay',
  SUPPORT_LANDING_ACCOUNT: '/support-landing/account',
  SIGNOUT: '/signout',
  HOME: 'home',
  MODIFY_CONFIRM: '/modify-cancellation/modify-confirm',
  MANAGE_PROFILE_ROUTE: '/my-profile',
  BROWSE_PLANS_ADD_FAN: 'browse-plans-phone?addToFan=true',
  STORE_OPS_ROUTE_OPEN_TILL: 'store-ops/open-pos-till',
  STORE_OPS_ROUTE_OPEN_STORE: 'store-ops/open-store',
  ACCOUNT_LANDING: '/account-landing',
};

export const CARE_MODULE_COMPONENTS = {
  CARE_MODULE: 'CareModule',
  CARE_COMPONENT: 'CareComponent',
};

export const RETAIL_MODULE_COMPONENTS = {
  RETAIL_MODULE: 'RetailModule',
  RETAIL_COMPONENT: 'RetailComponent',
};
export const RAP_MODULE_COMPONENTS = {
  RAP_MODULE: 'RapModule',
  RAP_COMPONENT: 'RapComponent',
};
export const INGENICO_MODULE_COMPONENTS = {
  INGENICO_MODULE: 'IngenicoModule',
  INGENICO_SERVICE: 'IngenicoService',
};

export const APP_PERMISSION = {
  DEVICES: 'See all devices',
  SHOP_NOW: 'Shop now',
  BROWSE_PHONES: 'Browse all phones',
  ENABLE: 'enable',
  BLOCK_DEVICE: 'Unlocking, blocking, and SIMs',
};
